<script setup lang="ts">
import {Trophy} from "@lucide/vue";
import {ContestPerformerResult} from "@/contest/interfaces";

const {result, isCurrentHealthcenter} = defineProps<{
    result: ContestPerformerResult;
    isCurrentHealthcenter?: boolean;
}>();

const getTrophyColor = (rank: number) => {
    switch (rank) {
        case 1:
            return 'text-yellow-500';
        case 2:
            return 'text-gray-400';
        case 3:
            return 'text-amber-700';
        default:
            return '';
    }
};
</script>

<template>
  <div class="flex items-center gap-2">
    <Trophy
      v-if="result.rank <= 3"
      :class="['w-5 h-5', getTrophyColor(result.rank)]"
    />
    <span v-else class="font-bold">
      #{{ result.rank }}
    </span>
    <p class="font-medium flex-1">
      {{ result.performer.name }}<span
        v-if="result.performer.metadata"
        class="text-sm text-gray-500"
      >, {{ result.performer.metadata }}</span>
    </p>
    <p class="font-bold text-primary">
      <span v-if="isCurrentHealthcenter">👉 </span>{{ result.score.formatted }}
    </p>
    <p v-if="result.details" class="text-primary opacity-70 text-sm">
      ({{ result.details }})
    </p>
  </div>
</template>

<style scoped>

</style>
